// Declarative site registry for Topazly Analytics Studio
// Adding a new site in the future only requires adding an entry here.

export const SITES = [
  {
    id: "all",
    name: "Portfolio Pulse",
    shortName: "Network",
    domain: "topazly.com",
    dataset: null, // Aggregates across datasets
    badge: "Pulse",
    badgeColor: "emerald",
    contentLabel: "Top Pages",
    contentPrefix: "/",
    hasDwell: true,
    conversionActions: [
      { event: "artwork_open", label: "Artwork Opens", color: "#f59e0b" },
      { event: "print", label: "Prints", color: "#6366f1" },
      { event: "print_click", label: "Print Store Clicks", color: "#6366f1" },
      { event: "download_pdf", label: "PDF Downloads", color: "#10b981" },
      { event: "wallpaper_download", label: "Wallpaper Downloads", color: "#10b981" },
      { event: "wallpaper_click", label: "Wallpaper Clicks", color: "#06b6d4" },
      { event: "affiliate_click", label: "Affiliate Clicks", color: "#f59e0b" },
      { event: "tool-used", label: "Tool Runs", color: "#3b82f6" },
      { event: "like_click", label: "Favorites / Likes", color: "#ec4899" },
      { event: "share_click", label: "Social Shares", color: "#3b82f6" },
      { event: "sign_in_click", label: "Sign-in Clicks", color: "#10b981" },
      { event: "auth_complete", label: "Sign-ins Completed", color: "#059669" },
      { event: "collect_click", label: "Collect / Save", color: "#14b8a6" },
      { event: "viewer_zoom", label: "Zoom / Inspect", color: "#8b5cf6" },
      { event: "bundle-download", label: "Bundles", color: "#06b6d4" },
      { event: "outbound_click", label: "Exit Clicks", color: "#ec4899" }
    ],
    description: "Real-time network traffic and conversion activity across all properties"
  },
  {
    id: "coloringremix",
    name: "Coloring Remix",
    shortName: "Coloring",
    domain: "coloringremix.com",
    dataset: "coloringremix_telemetry",
    badge: "Studio",
    badgeColor: "indigo",
    contentLabel: "Coloring Sheets",
    contentPrefix: "/pages/",
    hasDwell: true,
    conversionActions: [
      { event: "print", label: "Prints", color: "#6366f1" },
      { event: "download_pdf", label: "PDF Downloads", color: "#10b981" },
      { event: "bundle-download", label: "Bundles", color: "#06b6d4" },
      { event: "remix_cta", label: "Remix CTAs", color: "#8b5cf6" },
      { event: "affiliate_click", label: "Amazon Clicks", color: "#f59e0b" }
    ],
    description: "Printable coloring pages, PDF bundles, and art supplies affiliate conversions"
  },
  {
    id: "publicark",
    name: "PublicArk",
    shortName: "PublicArk",
    domain: "publicark.com",
    dataset: "publicark_engagement",
    badge: "Fine Art",
    badgeColor: "amber",
    contentLabel: "Artworks",
    contentPrefix: "/art/",
    hasDwell: true,
    conversionActions: [
      { event: "artwork_open", label: "Artwork Opens", color: "#f59e0b" },
      { event: "like_click", label: "Favorites / Likes", color: "#ec4899" },
      { event: "share_click", label: "Social Shares", color: "#3b82f6" },
      { event: "wallpaper_download", label: "Wallpaper Downloads", color: "#10b981" },
      { event: "wallpaper_click", label: "Wallpaper Clicks", color: "#06b6d4" },
      { event: "print_click", label: "Print Store Clicks", color: "#6366f1" },
      { event: "sign_in_click", label: "Sign-in Clicks", color: "#10b981" },
      { event: "auth_complete", label: "Sign-ins Completed", color: "#059669" },
      { event: "auth_prompt_shown", label: "Sign-in Prompts", color: "#8b5cf6" },
      { event: "collect_click", label: "Add to Board / Collect", color: "#14b8a6" },
      { event: "viewer_zoom", label: "Zoom & Inspect", color: "#a855f7" },
      { event: "expand_click", label: "Expand Views", color: "#8b5cf6" },
      { event: "guest_merge", label: "Guest Merges", color: "#64748b" },
      { event: "section_seen", label: "Section Impressions", color: "#3b82f6" }
    ],
    description: "Public domain fine art curation, deep dwell immersion, and museum provenance"
  },
  {
    id: "zeromod",
    name: "0mod Utilities",
    shortName: "0mod",
    domain: "0mod.com",
    dataset: "0mod_telemetry",
    badge: "Tools",
    badgeColor: "blue",
    contentLabel: "Utilities",
    contentPrefix: "/",
    hasDwell: true,
    conversionActions: [
      { event: "tool-used", label: "Tool Executions", color: "#3b82f6" },
      { event: "affiliate_click", label: "Ad Clicks", color: "#f59e0b" }
    ],
    description: "Client-side private PDF/HEIC converters and developer utilities"
  },
  {
    id: "x402",
    name: "x402 Gateway",
    shortName: "x402",
    domain: "api.0mod.com",
    dataset: "x402_telemetry",
    badge: "API",
    badgeColor: "purple",
    contentLabel: "Endpoints",
    contentPrefix: "/",
    hasDwell: false,
    conversionActions: [
      { event: "sku_request", label: "Paid Requests", color: "#3b82f6" },
      { event: "402_paywall", label: "402 Challenges", color: "#ef4444" }
    ],
    description: "HTTP 402 micro-payment metered API gateway"
  }
];

export const TIMEFRAMES = [
  { id: "1h", label: "1h", title: "Last Hour", interval: "1 HOUR", grain: "minute", tickCount: 12 },
  { id: "24h", label: "24h", title: "Last 24 Hours", interval: "24 HOUR", grain: "hour", tickCount: 24 },
  { id: "7d", label: "7d", title: "Last 7 Days", interval: "7 DAY", grain: "hour6", tickCount: 28 },
  { id: "30d", label: "30d", title: "Last 30 Days", interval: "30 DAY", grain: "day", tickCount: 30 }
];

export function getSiteById(id) {
  return SITES.find(s => s.id === id) || SITES[0];
}

export function getTimeframeById(id) {
  return TIMEFRAMES.find(t => t.id === id) || TIMEFRAMES[1];
}
